import React from "react";

interface OpinionCardProps {
  imageSrc: string;
  name: string;
  title: string;
  text: string;
  stars: number;
}

const OpinionCard: React.FC<OpinionCardProps> = ({
  imageSrc,
  name,
  title,
  text,
  stars,
}) => {
  return (
    <div className="opinion-card">
      <div className="opinion-card-image-container">
        <img src={imageSrc} alt={name} className="opinion-card-image" />
      </div>

      <div className="opinion-card-header">
        <h3 className="opinion-card-name">{name}</h3>
        <p className="opinion-card-title">{title}</p>
      </div>

      <p className="opinion-card-text">"{text}"</p>

      <div className="opinion-card-stars">{"★".repeat(stars)}</div>
    </div>
  );
};

export default OpinionCard;
